import { render, staticRenderFns } from "./swift-resolution.vue?vue&type=template&id=7597b928&scoped=true"
import script from "./swift-resolution.vue?vue&type=script&lang=js"
export * from "./swift-resolution.vue?vue&type=script&lang=js"
import style0 from "./swift-resolution.vue?vue&type=style&index=0&id=7597b928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597b928",
  null
  
)

export default component.exports